import React from "react";
import styled, { useTheme } from "styled-components";

import { get } from "@/utils/theme-gets";

export type MondayIconProps = {
  Icon: JSX.Element;
  size?: number;
  color?: string;
  className?: string;
};

export const MondayIcon: React.FC<MondayIconProps> = ({ Icon, size, color, className }) => {
  const theme = useTheme();
  const iconSize = size || 20;
  const iconColor = color || (get(theme, "color.foreground.icon.secondary", "") as string);

  return (
    <IconContainer className={className} $size={iconSize} $color={iconColor}>
      {Icon}
    </IconContainer>
  );
};

const IconContainer = styled.i<{ $size: number; $color: string }>`
  display: flex;
  color: ${(p) => p.$color};
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
`;
